/* AMTENDENCY — remonte do painel de filtros.

   O `renderFilters` do Dawn remonta o painel casando elemento a elemento por
   id: remove do DOM o que o servidor não devolveu, insere o que falta e, na
   inserção, faz

     document.getElementById(idDoAnterior).after(novoElemento)

   O `idDoAnterior` é o do elemento anterior da lista VINDA DO SERVIDOR — que
   pode ainda não existir no DOM, porque acabou de ser criado na mesma passada.
   Aí `getElementById` devolve null, o `.after` estoura e o `renderFilters`
   morre no meio: os grupos que faltavam nunca entram e o painel fica pela
   metade — ou vazio, se a remoção rodou antes.

   A forma da lista de filtros muda de verdade: a Search & Discovery devolve
   grupos diferentes conforme o que sobrou, e some com todos quando a
   combinação zera os produtos. É exatamente aí que o painel some.

   Aqui o painel do celular é trocado INTEIRO, de uma vez, a partir do HTML que
   o servidor acabou de responder — que é o que a referência faz com a barra
   lateral dela. Sem casamento por id, sem remoção, sem `.after` em null.

   O caminho do Dawn continua rodando antes (ele cuida do desktop, das
   pastilhas e das contagens), mas dentro de um `try`: se cair, o painel já é
   remontado logo abaixo assim mesmo. */
(function () {
  // `class FacetFiltersForm` no topo de um script clássico entra no escopo
  // léxico global, NÃO em `window` — `window.FacetFiltersForm` é undefined e
  // uma guarda por ele aborta o override sem avisar. O `typeof` no nome puro
  // não estoura nem se a classe não existir.
  if (typeof FacetFiltersForm === 'undefined') return;

  var original = FacetFiltersForm.renderFilters;

  FacetFiltersForm.renderFilters = function (html, event) {
    try {
      original.call(this, html, event);
    } catch (e) {
      // o casamento por id do Dawn é frágil; o painel é remontado abaixo
      if (window.console && console.warn) console.warn('renderFilters do Dawn falhou:', e);
    }

    var novo = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsWrapperMobile');
    var atual = document.getElementById('FacetsWrapperMobile');
    if (!novo || !atual) return;

    // Sem isto o navegador guarda a posição da rolagem do painel e ela volta
    // ao topo a cada clique.
    var rolagem = atual.scrollTop;
    atual.innerHTML = novo.innerHTML;
    atual.scrollTop = rolagem;

    // A gaveta reata os próprios eventos: o innerHTML novo trouxe elementos
    // que ela escutava (o `renderAdditionalElements` do Dawn faz o mesmo, mas
    // rodou antes da troca).
    var gaveta = atual.closest('menu-drawer');
    if (gaveta && typeof gaveta.bindEvents === 'function') gaveta.bindEvents();
  };
})();
